
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/headshot-generator",
      function () {
        return require("private-next-pages/headshot-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/headshot-generator"])
      });
    }
  